import React from 'react'
import { useGetRoute } from '@/lib/react-query'
import ScheduleSection from '@/components/ScheduleSection'
import Typography from '@/components/ui/Typography'
import { useGuideUrl } from '@/features/zendesk-app'
import Button from '@/components/ui/Buttons/Button'
import classes from './DeployButton.module.scss'

export type CronDeployInstructionsProps = {
  projectId: number
  routeId: number
}

const CronDeployInstructions = ({ projectId, routeId }: CronDeployInstructionsProps) => {
  const {
    data: { route },
  } = useGetRoute(projectId, routeId)
  const guideUrl = useGuideUrl()
  const openDeployArticle = () => window.open(guideUrl, '_blank')

  return (
    <div className={classes.cronRoot}>
      <Typography>Route runs automatically on:</Typography>
      <ScheduleSection value={route.schedule} />
      <Button variant={'outlined'} color={'neutral'} onClick={openDeployArticle} onAuxClick={openDeployArticle}>
        Knots Studio Guide
      </Button>
    </div>
  )
}

export default CronDeployInstructions
